import React from 'react';
import PropTypes from 'prop-types';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import TuneRoundedIcon from '@material-ui/icons/TuneRounded';
import styles from './SetupIncompleteBanner.module.scss';

export default function SetupIncompleteBanner({ message, actionLabel, onAction }) {
  return (
    <section
      className={styles.root}
      data-testid="setup-incomplete-banner"
      role="status"
      aria-label={message}
    >
      <span className={styles.icon} aria-hidden="true">
        <TuneRoundedIcon />
      </span>
      <div className={styles.copy}>
        <span className={styles.message}>{message}</span>
      </div>
      <button className={styles.action} type="button" onClick={onAction}>
        <span>{actionLabel}</span>
        <ArrowForwardRoundedIcon aria-hidden="true" />
      </button>
    </section>
  );
}

SetupIncompleteBanner.propTypes = {
  message: PropTypes.string.isRequired,
  actionLabel: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
};
